import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';
import { ArrowRight, Brush, Calculator, Home, Palette, Shield } from '../ui/Icons';

const STEPS = [
  { Icon: Palette, title: 'Choose your colours', copy: 'Browse the catalogue, order samples or book a colour consultant.', to: '/colours/catalogue' },
  { Icon: Calculator, title: 'Estimate the job', copy: 'Enter your area to get paint quantity and an indicative budget.', to: '/CalculateNow' },
  { Icon: Home, title: 'Inspect the surface', copy: 'Our team checks damp, cracks and old paint before recommending a system.', to: '/services/safe-painting' },
  { Icon: Brush, title: 'Paint with care', copy: 'Trained applicators mask, prime and apply two finish coats.', to: '/services/book-painter' },
  { Icon: Shield, title: 'Enjoy the finish', copy: 'A clean handover, and a performance warranty on eligible products.', to: '/services' },
];

/** Five-step journey laid over a full-width photograph, in a single glass panel. */
const PaintingJourney = () => (
  <section className="relative overflow-hidden">
    <img src="/images/web/villa-pool.jpg" alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-brand-navy/70" />
    <div className="relative container py-16 md:py-24">
      <div className="max-w-2xl text-white">
        <span className="vp-eyebrow vp-eyebrow-light">From idea to finished wall</span>
        <h2 className="vp-heading !text-white mt-4 text-3xl sm:text-4xl lg:text-[2.75rem]">Five steps to a home you will love coming back to</h2>
        <p className="mt-4 text-white/75 leading-relaxed">Whether you paint one room or a whole building, the process is the same — and we are with you at every step.</p>
      </div>

      <ol className="mt-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {STEPS.map(({ Icon, title, copy, to }, i) => (
          <Reveal as="li" key={title} delay={(Math.min(i, 4) as 0 | 1 | 2 | 3 | 4)}>
            <Link to={to} className="group relative block h-full bg-white rounded-2xl p-6 shadow-lift hover:-translate-y-1.5 transition-transform duration-300">
              <span className="absolute top-5 right-5 text-4xl font-bold text-brand-line leading-none">{String(i + 1).padStart(2, '0')}</span>
              <span className="w-12 h-12 rounded-2xl bg-gradient-to-br from-brand-blue to-brand-red text-white flex items-center justify-center shadow-blue">
                <Icon size={20} />
              </span>
              <h3 className="mt-5 text-base font-semibold text-brand-ink">{title}</h3>
              <p className="mt-2 text-sm text-brand-muted leading-relaxed">{copy}</p>
              <span className="mt-4 vp-link text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                Start <ArrowRight size={14} />
              </span>
            </Link>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default PaintingJourney;
